import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, ABC_FMS_ANALYSIS } from './constants';
import List from './List.vue';

export const router = new Path(ABC_FMS_ANALYSIS, { List }, CRUMB_LABEL_KEY);
